import { useEffect, useState } from "react";
import { ISystemData } from "../types/resource";
import { getResourceAuthTagDetails } from "../services/resourcesService";

const useFetchResourceAuthTagDetails = ({ setIsLoading, resourceId }: any) => {
  const [resourceAuthTagDetails, setResourceAuthTagDetails] = useState<
    ISystemData[]
  >([]);
  useEffect(() => {
    const getResourceAuthTagDetailsData = async () => {
      setIsLoading(true);
      try {
        const result: ISystemData[] = await getResourceAuthTagDetails(
          resourceId
        );
        setResourceAuthTagDetails(result);
      } catch (err) {
        console.error("Error fetching resource auth tag details:", err);
        setResourceAuthTagDetails([]);
      } finally {
        setIsLoading(false);
      }
    };

    // Only call API if resourceId is valid
    if (resourceId && resourceId > 0) {
      getResourceAuthTagDetailsData();
    } else {
      setResourceAuthTagDetails([]);
    }
  }, [resourceId]);

  return [resourceAuthTagDetails];
};

export default useFetchResourceAuthTagDetails;
